import React, { useState, useEffect, useRef } from "react";
import M from "materialize-css";
import { useHistory, useParams } from "react-router-dom";
import Config from "../../../config/Config";
import Breadcrumb from "../../components/Breadcrumb";
import Spinner from "../../components/Spinner";
import Select from "react-select";
import date from "date-and-time";
import DcaAdcaCertificate from "../../components/DcaAdcaCertificate";
import TypingCertificate from "../../components/TypingCertificate";
import { useReactToPrint } from "react-to-print";

const DownloadCertificte = () => {
  const { id, sign } = useParams();

  const [loading, setLoading] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState([]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [certificate, setCertificate] = useState({
    studentName: "",
    fatherName: "",
    description: "",
  });

  // get Certificate
  useEffect(() => {
    fetch(`${Config.SERVER_URL}/certificates/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt_admin_token")}`,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.status === 200) {
            setCertificate(result.body);
            document.title = `${result?.body?.student?.name?.replaceAll(
              " ",
              "-"
            )}-${result?.body?.course?.name?.replaceAll(" ", "-")}`;
          } else {
            M.toast({ html: result.message, classes: "bg-danger" });
          }
        },
        (error) => {
          M.toast({ html: error, classes: "bg-danger" });
        }
      );
  }, []);

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        {/* <!-- ============================================================== --> */}
        {/* <!-- Bread crumb and right sidebar toggle --> */}
        {/* <!-- ============================================================== --> */}

        <Breadcrumb
          title={"DOWNLOAD CERTIFICATE"}
          pageTitle={"Download Certificate"}
        />

        {/* Update Form */}
        <div className="row">
          <div className={"col-md-11 mx-auto"}>
            {/* Certificate Details */}
            <div className={"row shadow-sm bg-white py-3"}>
              {certificate?.course?.certificateFileName ==
              "dca-adca-format.jpg" ? (
                <DcaAdcaCertificate
                  ref={componentRef}
                  serialNumber={certificate.serialNumber}
                  regNumber={certificate.regNumber}
                  courseFullName={certificate?.course?.fullName}
                  courseName={certificate?.course?.name}
                  studentName={certificate?.student?.name}
                  fatherName={certificate?.student?.fatherName}
                  grade={certificate.grade}
                  batchStartDate={certificate.batchStartDate}
                  batchEndDate={certificate.batchEndDate}
                  printFontSize={certificate.course?.printFontSize}
                  certificateIssuesDate={certificate.certificateIssuesDate}
                  documentTitle="Certificate"
                  sign={sign}
                />
              ) : certificate?.course?.certificateFileName ==
                "typing-format.jpg" ? (
                <TypingCertificate
                  ref={componentRef}
                  serialNumber={certificate.serialNumber}
                  regNumber={certificate.regNumber}
                  courseFullName={certificate?.course?.fullName}
                  courseName={certificate?.course?.name}
                  studentName={certificate?.student?.name}
                  fatherName={certificate?.student?.fatherName}
                  accuracy={certificate.accuracy}
                  avgSpeed={certificate.avgSpeed}
                  grade={certificate.grade}
                  batchStartDate={certificate.batchStartDate}
                  batchEndDate={certificate.batchEndDate}
                  printFontSize={certificate.course?.printFontSize}
                  certificateIssuesDate={certificate.certificateIssuesDate}
                  documentTitle="Certificate"
                  sign={sign}
                />
              ) : null}

              <div className={"form-group col-md-12 text-center"}>
                <button
                  className="btn btn-danger rounded-0"
                  onClick={handlePrint}
                >
                  Print this out!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadCertificte;
